var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAuthenticate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.09091C8.19155 5.09091 8.37525 5.16753 8.51069 5.30392C8.64613 5.44031 8.72222 5.6253 8.72222 5.81818C8.72222 6.01107 8.64613 6.19605 8.51069 6.33244C8.37525 6.46883 8.19155 6.54545 8 6.54545C7.80845 6.54545 7.62475 6.46883 7.48931 6.33244C7.35387 6.19605 7.27778 6.01107 7.27778 5.81818C7.27778 5.6253 7.35387 5.44031 7.48931 5.30392C7.62475 5.16753 7.80845 5.09091 8 5.09091ZM14.5 7.27273C14.5 11.3091 11.7267 15.0836 8 16C4.27333 15.0836 1.5 11.3091 1.5 7.27273V2.90909L8 0L14.5 2.90909V7.27273ZM8 3.63636C7.42536 3.63636 6.87426 3.86623 6.46794 4.2754C6.06161 4.68457 5.83333 5.23953 5.83333 5.81818C5.83333 6.77091 6.43278 7.57818 7.27778 7.87636V12.3636H8.72222V10.9091H10.1667V9.45455H8.72222V7.87636C9.56722 7.57818 10.1667 6.77091 10.1667 5.81818C10.1667 5.23953 9.93839 4.68457 9.53206 4.2754C9.12574 3.86623 8.57464 3.63636 8 3.63636Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAuthenticate);
export default __webpack_public_path__ + "static/media/icon-authenticate.c6aa853d270186657e079ef91dc7b238.svg";
export { ForwardRef as ReactComponent };